<template lang="pug">
  #statistics
    Header
    v-container(fluid)
      v-layout.py-3(row wrap justify-center)
        v-tabs(fixed-tabs)
          v-tab(v-for="(section, index) in sections" :key="index" v-on:click="setTab(section, index)" v-model="activeTabIndex")
            p.bolder {{ section.text }}
          v-tab-item(v-for="(section, index) in sections" :key="section.value")
            v-layout.mt-4.py-3(row wrap justify-center :id="'downloadable' + index")
              v-flex.summary-box.my-0.pa-2(xs10 offset-xs1 d-flex)
                v-flex(xs4)
                  p.bold Total de asesorías atendidas:
                    span.dark-text &nbsp;{{ reports.length }}
                v-flex(xs4)
                  p.bold Total de tiempo invertido:
                    span.dark-text &nbsp;{{ totalHours }}h {{ totalMinutes }}' 
                v-flex(xs4)
                  p.bold Promedio de tiempo por asesoría:
                    span.dark-text &nbsp;{{ averageHours }}h {{ averageMinutes.toFixed(2) }}'
              v-flex.chart-box.pa-4(xs10 offset-xs1 d-flex)
                v-flex(xs3)
                  v-layout(column align-center justify-center)
                    v-btn-toggle(v-model="activeOption" )
                      v-btn.chart-btn(v-for="(option, i) in options[index]" :key="i" @click="setData(option,i)") {{option.text}}
                v-flex(xs9 :class="['chart-' + index.toString()]")
                  v-flex.mb-3(row justify-center d-flex)
                    v-flex.switch(xs3 d-flex)
                      p.mr-2 Tabla
                      v-switch(
                        v-model="viewChart"
                        hide-details=true
                      )
                      p Gráfica
                  svg(width="600px" height="300px" v-if="viewChart")
                  v-data-table.ml-5(
                    v-if="!viewChart"
                    :headers="headers"
                    :items="dataset"
                    hide-actions
                  )
                    template(slot="items" slot-scope="props")
                      td {{ props.item.key }}
                      td {{ props.item.value }}
      
      v-container
        v-layout.py-3(row wrap justify-end)
          v-btn.px-2.bold.main-color-button(@click="downloadChart()") Descargar
        
</template>
<script>
import Header from "@/components/Header.vue";
import * as d3 from "d3";
import * as html2canvas from "html2canvas";
import chartModule from "@/services/dcbox.js";

export default {
  name: "Statistics",
  components: {
    Header
  },
  data() {
    return {
      headers: [
        { text: 'Categoría', value: 'key' },
        { text: 'Total', value: 'value' },
      ],
      viewChart: true,
      sections: [
        {
          text: 'Sobre la gestión',
          value: 'attention'
        },
        {
          text: 'Sobre los solicitantes',
          value: 'petitioner'
        },
        {
          text: 'Sobre el contenido',
          value: 'synthesis'
        }
      ],
      options: [
        [
          {
            text: "¿Quién atendió?", 
            value: "advisoryProvider"
          },
          {
            text: "Asesorías por año",
            value: "attentionDate"
          }
        ],
        [
          {
            text: "Sexo",
            value: "sex"
          },
          {
            text: "Ocupación",
            value: "occupation"
          },
          {
            text: "Edad",
            value: "age"
          },
          {
            text: "Estado Civil",
            value: "civilStatus"
          },
          {
            text: "Cómo supo del CDDHFJL",
            value: "hearFromOrg"
          }
        ],
        [
          {
            text: "Lugar de los hechos",
            value: "state"
          },
          {
            text: "Asunto de la asesoría",
            value: "matter"
          },
          {
            text: "Tipo de intervención",
            value: "intervention"
          },
          {
            text: "Canalización",
            value: "referred"
          }
        ]
      ],
      activeTabIndex: 0,
      activeOption: 0,
      activeTab: {
        text: 'Sobre la gestión',
        value: 'attention'
      },
      colors: ["#a04085", "#a4488a", "#a95190", "#b2649c", "#b66ca1", "#bb75a7"],
      totalHours: 0,
      totalMinutes: 0,
      averageHours: 0,
      averageMinutes: 0,
      dataset: []
    }
  },
  computed: {
    reports() {
      const processed = this.$store.state.reports.map(el => {
        // Keep only year of attentionDate
        if (el.attention.attentionDate)
          el.attention.attentionDate = new Date(el.attention.attentionDate).getFullYear();
        
        // Simplify checkbox data
        const matter = el.synthesis.matter;
        let matterProcessed = {};
        Object.keys(matter).map(int => {
          const newKey = matter[int].text;
          const isSelected = matter[int].isSelected;
          matterProcessed[newKey] = isSelected ? 1 : 0;
        });
        el.synthesis.matter = matterProcessed;

        const intervention = el.synthesis.intervention;
        let interventionProcessed = {};
        Object.keys(intervention).map(int => {
          const newKey = intervention[int].text;
          const isSelected = intervention[int].isSelected;
          interventionProcessed[newKey] = isSelected ? 1 : 0;
        });
        el.synthesis.intervention = interventionProcessed;

        const referred = el.synthesis.referred;
        let referredProcessed = {};
        Object.keys(referred).map(int => {
          const newKey = referred[int].text;
          const isSelected = referred[int].isSelected;
          referredProcessed[newKey] = isSelected ? 1 : 0;
        });
        el.synthesis.referred = referredProcessed;

        return el; 
      });

      return processed;
    }
  },
  watch: {
    viewChart: function(newValue, oldValue) {
      if (newValue) {
        setTimeout(()=>{this.draw(this.activeTabIndex)}, 50);//this.draw(this.activeTabIndex);
      }
    }
  },
  methods: {
    setTab(section, index) {
      this.activeTab = section;
      this.activeTabIndex = index;
      this.activeOption = 0;
      this.setData();
    },
    draw(which, sectionSelected) {
      d3.selectAll("svg").selectAll('*').remove();
      const svg = d3.select(".chart-" + which + " svg");
      const width = svg.attr("width").replace("px","");
      const height = svg.attr("height").replace("px","");

      const config = {
        size: {
          width: width,
          height: height,
          margin: {
            left: 60,
            right: 10,
            top: 10,
            bottom: 70
          }
        },
        xAxis: {
          enabled: true,
          scale: "band",
          ticks: {
            enabled: true
          }
        },
        yAxis: {
          enabled: true,
          scale: "linear",
          ticks: {
            enabled: true,
            style: "dashLine",
            format: d3.format(",.0f"),
          },
          minZero: true
        }
      };

      const sortBy = this.activeOption == 2 && this.activeTabIndex == 1 ? "key" : "value";
      var bars = chartModule
        .config(config)
        .bindTo(".chart-" + which + " svg")
        .data({ raw: this.dataset })
        .layer("bars")
        .fill("key")
        .colors(this.colors)
        .sortBy([sortBy]);

      bars.x("key").y("value");

      chartModule.draw();
    },
    setData(event = this.options[this.activeTabIndex][0], index = 0) {
      const subject = event.value == 'hearFromOrg' ? 'attention' : this.activeTab.value;
      this.activeOption = index;

      if (event.value == 'matter' || event.value == 'intervention' || event.value == 'referred') {
        const keys = Object.keys(this.reports[0][subject][event.value]);
        this.dataset = keys.map(k => {
          const total = this.reports.map(report => {
            return report[subject][event.value][k];
          }).reduce((accumulated, current) => { return accumulated + current; });
          return {
            key: k,
            value: total
          }
        }).filter(report => { return report.value > 0 });
      }
      else {
        this.dataset = d3.nest()
          .key((d) => { return d[subject][event.value]; })
          .rollup(function(v) { return v.length; })
          .entries(this.reports);
      }
      if (this.viewChart) this.draw(this.activeTabIndex, event);
    },
    getTimes() {
      const allMinutes = this.reports.reduce((prev,curr) => {
        return prev + parseInt(curr.attention.minutes);
      },0);
      
      this.totalHours = Math.floor(allMinutes / 60);
      this.totalMinutes = allMinutes % 60;

      if (this.reports.length > 0) {
        const average = allMinutes / this.reports.length;
        this.averageHours = Math.floor(average / 60);
        this.averageMinutes = average % 60;
      }
    },
    getReports() {
      this.$store.dispatch("getReports");
    },
    downloadChart() {
      d3.selectAll('.switch').style('opacity', 0);
      return new Promise((resolve, reject) => {
        html2canvas(d3.select('#downloadable' + this.activeTabIndex).node()).then(canvas => {
          const linkChart = document.createElement("a");
          linkChart.setAttribute("href", canvas.toDataURL("image/jpeg"));
          linkChart.setAttribute("download", "estadisticas.jpeg");
          document.body.appendChild(linkChart);
          linkChart.click();
          d3.selectAll('.switch').style('opacity', 1);
        }, {allowTaint: true, useCors: true});
      });
    }
  },
  mounted() {
    this.setData();
    this.getTimes();
    if (!this.reports.length > 0) {
      this.getReports();
      setTimeout(()=> {
        this.getTimes();
        this.setData();
      }, 500);
    }
  }
}
</script>
<style lang="scss" scoped>
.tabs, .v-tabs {
  max-width: 1300px;
  width: 90%;
}
.v-window .v-window__container .v-window-item .summary-box, .summary-box {
  background-color: #d8d8d8;
}
.v-window .v-window__container .v-window-item .chart-box, .chart-box {
  background-color: #f0f0f0;
  max-width: 1300px !important;
}
.switch, label {
  p {
    display: flex;
    align-items: center;
    padding-bottom: 5px;
    font-size: 14px;
    font-weight: bold;
    color: #414040;
  }
  .input-group.input-group--dirty, .input-group--selection-controls {
    width: auto;
  }
}
.main-color-button {
  border-radius: 8px;
}
</style>
